/* SVEVA by LINTEL PDP: gallery (counter/thumbs), review slider, load more, sticky ATC, every add -> SVV brand cart drawer (never /cart) */
(function () {
  var tr = document.querySelector('[data-svv-track]'), thumbs = document.querySelector('[data-svv-thumbs]'), cnt = document.querySelector('[data-svv-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('[data-svv-rs]').forEach(function (c) {
    var t = c.querySelector('.svv-rs__track');
    c.querySelectorAll('.svv-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });
  var more = document.querySelector('[data-svv-more]'), list = document.querySelector('[data-svv-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var form = document.getElementById('svv-buy');
  document.querySelectorAll('[data-svv-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var t = document.querySelector('.kaching-bundles') || form;
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    });
  });
  /* Kaching colour choice -> show that colour's hero (image 1 = Jet Black, image 2 = Royal Navy) */
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s || !s.closest || !s.closest('.kaching-bundles') || s.tagName !== 'SELECT') return;
    var t = (s.options[s.selectedIndex] || {}).text || '';
    if (/navy/i.test(t)) go(1); else if (/black/i.test(t)) go(0);
  }, true);
  var st = document.querySelector('[data-svv-sticky]');
  if (st && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
  var sa = document.querySelector('[data-svv-sticky-atc]');
  if (sa && form) sa.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
  });
})();

/* Add to cart NEVER goes to /cart (Edvin 10-02): every /cart/add form opens the SVV brand cart drawer */
(function () {
  if (window.__svv_atc) return; window.__svv_atc = 1;
  function open() { if (window.SVV && window.SVV.openCart) return window.SVV.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
